/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBillingOntologySyncAdhoc extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBillingOntologySyncAdhoc");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBillingOntologySyncAdhoc.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBillingOntologySyncAdhoc>): BackgroundJobPayloadForBillingOntologySyncAdhoc {
        let obj = Object.assign(new BackgroundJobPayloadForBillingOntologySyncAdhoc(), model);
        BackgroundJobPayloadForBillingOntologySyncAdhoc.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBillingOntologySyncAdhoc>): BackgroundJobPayloadForBillingOntologySyncAdhoc {
        if (!model) return null;
        return BackgroundJobPayloadForBillingOntologySyncAdhoc.newInstance(<BackgroundJobPayloadForBillingOntologySyncAdhoc> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBillingOntologySyncAdhoc) {
        if (!obj) return;

        models.BackgroundJobPayloadForBillingOntologySyncAdhoc.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBillingOntologySyncAdhoc): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBillingOntologySyncAdhoc.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
